export class Senf {

    _machVal!: number;
    _gammaVal!: number;
    _pressureRat!: number;
    _tempRat!: number;
    _areaRat!: number;
    _machAng!: number;
    _paptas!: number;
    _pmr!: number;
    _cfopt!: number;
    _rho_rhot!: number;

    constructor() {
        this._machVal = 0;
        this._areaRat = 0;
        this._gammaVal = 1.4;
        this._machAng = 0;
        this._pmr = 0;
        this._cfopt = 0;
        this._rho_rhot = 0;
        this._tempRat = 0;
        this._paptas = 0;
        this._pressureRat = 0;
    }


    senfCalc(g:number, m:number) {
       
        let g2 = Math.pow(g,2);
        let gm1 = g-1;
        let gp1 = g+1;
        let gm1_2 = gm1/2;
        let gp1_2 = gp1/2;
        let m2 = Math.pow(m,2);
        let invm2 = 1/(m2);

        console.log(m);

        let invm = 1/m;

        console.log(invm);


        let frac = gp1 / (2*(gm1));


        if (this._pressureRat === 0) {
            this._pressureRat = Math.pow( 1 / ( 1 + (gm1_2 * m2)), (g/gm1) );
        }

        if (this._areaRat === 0) {
            this._areaRat = (Math.pow( gp1_2, -frac)) *  invm * (Math.pow( 1+ (gm1_2 *m2), frac));
        }

        
        if (this._tempRat === 0) {
            this._tempRat = Math.pow(1 + (gm1_2 * m2), -1);
        }


        if (this._paptas === 0) {
            this._paptas = this._areaRat * this._pressureRat;
        }


        let radian_mu = Math.asin(invm);
        console.log(radian_mu);
        if (this._machAng === 0) {
            this._machAng = (180/Math.PI) * radian_mu;
        }

        let m2_1 = Math.pow(m, 2) - 1;
        let part1 = Math.sqrt( gp1/gm1 );
        let part2 = Math.atan(  Math.sqrt ( (gm1/gp1) * m2_1 ) );
        let part3 = Math.atan( Math.sqrt( m2_1) ) ;
        let p_m = (part1 * part2) - part3;
        this._pmr = (180/Math.PI) * p_m;
        this._cfopt = Math.sqrt( Math.pow( (2/gp1), (gp1/gm1) ) * g2 * m2 * 1/( 1 + (gm1/2)*m2) );
        this._rho_rhot = Math.pow( 1 / ( 1 + ( (gm1/2) * m2) ) , 1/gm1 );
    }

    get machVal(): number {
        return this._machVal;
    }

    set machVal(value) {
        this._machVal = value;
    }

    get gammaVal(): number {
        return this._gammaVal;
    }

    set gammaVal(value) {
        this._gammaVal = value;
    }

    get areaRat(): number {
        return this._areaRat;
    }

    set areaRat(value) {
        this._areaRat = value;
    }

    get tempRat(): number {
        return this._tempRat;
    }

    get paptas(): number {
        return this._paptas;
    }

    set paptas(value) {
        this._paptas = value;
    }

    get pmr(): number {
        return this._pmr;
    }

    get machAng(): number {
        return this._machAng;
    }


    set machAng(value) {
        this._machAng = value;
    }


    get cfOpt(): number {
        return this._cfopt;
    } 

    get rhorhot(): number {
        return this._rho_rhot;
    }

    get pressureRat(): number {
        return this._pressureRat;
    }





}
